<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 项目相关</el-breadcrumb-item>
                <el-breadcrumb-item>项目组</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='20'>
                        <el-form :model='queryParams' ref='queryForm' size='small' :inline='true' v-show='showSearch'>
                            <el-form-item style='margin-bottom: 0' label='项目组名称' prop='dictName'>
                                <el-input
                                    v-model='queryParams.projectGroupName'
                                    placeholder='请输入项目组名称'
                                    clearable
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='项目id' prop='dictType'>
                                <el-input
                                    v-model='queryParams.projectId'
                                    placeholder='请输入项目id'
                                    clearable
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0' label='角色id' prop='status'>
                                <el-select
                                    v-model='queryParams.roleId'
                                    placeholder='角色列表'
                                    clearable
                                    style='width: 240px'
                                >
                                    <el-option
                                        v-for='role in roleList'
                                        :key='role.roleId'
                                        :label='role.roleName'
                                        :value='role.roleId'
                                    />
                                </el-select>
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button type='primary' icon='el-icon-search' size='mini' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='4'>
                        <el-row style="float: right; margin-right: 20px" :gutter='10' class='mb8'>
                            <el-col :span='1.5'>
                                <el-button
                                    type='primary'
                                    plain
                                    icon='el-icon-plus'
                                    size='mini'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table :cell-style="{ textAlign: 'center' }" v-loading='loading' :data='projectGroupList'
                      @selection-change='handleSelectionChange'>
                <el-table-column type='selection' width='55' align='center' />
                <el-table-column label='项目组id' align='center' prop='id' />
                <el-table-column label='项目组名称' align='center' prop='name' :show-overflow-tooltip='true' />
                <el-table-column label='项目名称' align='center' :show-overflow-tooltip='true'>
                    <template slot-scope='scope'>
                        <span>{{ computeProjectInfo(scope.row.projectId) }}</span>
                    </template>
                </el-table-column>
                <el-table-column label='角色名称' align='center' :show-overflow-tooltip='true'>
                    <template slot-scope='scope'>
                        <span>{{computeRoleInfo(scope.row.roleId)}}</span>
                    </template>
                </el-table-column>
                <el-table-column label='创建时间' align='center' prop='createTime' width='180'>
                    <template slot-scope='scope'>
                        <span>{{ scope.row.createTime }}</span>
                    </template>
                </el-table-column>
                <el-table-column v-if='computeUserRole' label='操作' align='center' class-name='small-padding fixed-width'>
                    <template slot-scope='scope'>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-edit'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            size='mini'
                            type='text'
                            icon='el-icon-delete'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                        <el-button
                            icon='el-icon-circle-check'
                            size='mini'
                            type='text'
                            @click='editGroupMember(scope.row)'
                        >人员管理
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
    
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' width='500px' append-to-body>
                <el-descriptions size='medium' :column='1' direction='horizontal'>
                    <el-descriptions-item :span='2' label="项目组名称">{{currentProjectGroup.name}}</el-descriptions-item>
                    <el-descriptions-item label="项目">
                        <el-select
                            v-model='currentProjectGroup.projectId'
                            placeholder='请选择项目'
                            clearable
                            filterable
                            size='mini'
                            @change='handleChangeOnProject'
                            style='width: 300px'
                        >
                            <el-option
                                v-for='project in projectDataList'
                                :key='project.id'
                                :label='project.cnName'
                                :value='project.appId'
                            />
                        </el-select>
                    </el-descriptions-item>
                    <el-descriptions-item label="角色">
                        <el-select
                            v-model='currentProjectGroup.roleId'
                            placeholder='请选择角色'
                            clearable
                            filterable
                            size='mini'
                            @change='handleChangeOnRole'
                            style='width: 300px'
                        >
                            <el-option
                                v-for='role in roleList'
                                :key='role.roleId'
                                :label='role.roleName'
                                :value='role.roleId'
                            />
                        </el-select>
                    </el-descriptions-item>
                </el-descriptions>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog title='组成员列表' @close='cancelEditGroupMember' :visible.sync='openGroupMembers' width='50%'
                       append-to-body>
                <el-transfer :titles='["未添加", "已添加"]' v-model='addedUserList' :data='allUserList'></el-transfer>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitEditGroupMember'>确 定</el-button>
                    <el-button @click='cancelEditGroupMember'>取 消</el-button>
                </div>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import {
    deleteProjectGroup,
    insertProjectGroup,
    selectProjectGroupList,
    updateProjectGroup
} from '@/components/api/projectGroup';
import { message } from '@/utils/message';
import { selectRoleList } from '@/components/api/role';
import { localStg } from '@/utils/storage/local';
import { queryProjectInfoList } from '@/components/api/ProjectInfo';
import { deepCopy } from '@/utils/object';
import { getAllMemberName } from '@api/log';
import { deleteUsersFromProjectGroup, insertProjectGroupsForUsers, queryGroupMembers } from '@api/rolePermission';

export default {
    name: 'Dict',
    data() {
        return {
            roleList: [],
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            // 显示搜索条件
            showSearch: true,
            // 总条数
            total: 0,
            projectGroupList: [],
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            // 查询参数
            queryParams: {
                total: 1,
                pageNum: 1,
                pageSize: 15,
                projectId: undefined,
                id: undefined,
                roleId: '',
                tag: undefined
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                name: [
                    { required: true, message: '项目组名称不能为空', trigger: 'blur' }
                ],
                projectId: [
                    { required: true, message: '项目组不能缺项目', trigger: 'blur' }
                ],
                roleId: [
                    { required: true, message: '项目组不能缺角色', trigger: 'blur' }
                ]
            },
            updateStatus: false,
            // 所有项目
            projectDataList: [],
            currentProjectGroup: {
                name: undefined,
                projectId: undefined,
                roleId: undefined,
                currentRoleName: undefined,
                currentProjectName: undefined
            },
            openGroupMembers: false,
            
            groupUserIdList: [],
            addedUserList: [],
            allUserList: []
        };
    },
    computed: {
        computeUserRole() {
            return localStg.get("administrator")
        },
        computeProjectInfo() {
            return (projectId) => {
                for (let i = 0; i < this.projectDataList.length; i++) {
                    if (projectId === this.projectDataList[i].appId) {
                        return this.projectDataList[i].cnName
                    }
                }
            }
        },
        computeRoleInfo() {
            return (roleId) => {
                for (let i = 0; i < this.roleList.length; i++) {
                    if (roleId === this.roleList[i].roleId) {
                        return this.roleList[i].roleName
                    }
                }
            }
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum
            this.getList()
        },
        resetForm(refName) {
            if (this.$refs[refName]) {
                this.$refs[refName].resetFields();
            }
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            const param = this.queryParams;
            this.currentProjectGroup = {
                name: undefined,
                projectId: undefined,
                roleId: undefined,
                currentRoleName: undefined,
                currentProjectName: undefined
            }
            selectProjectGroupList(param.id, param.projectGroupName, param.projectId, param.roleId, param.pageNum, null).then(response => {
                if (response.code === 200) {
                    this.projectGroupList = response.data.result;
                    this.queryParams.total = response.data.total;
                    this.loading = false;
                }else {
                    this.loading = false
                }
            })
            
            selectRoleList(null, null, null).then(result => {
                if (result.code === 200) {
                    this.roleList = result.data.result
                }
            })
            
            queryProjectInfoList({pageSize: 10000}).then(result => {
                if (result.code === 200) {
                    this.projectDataList = result.data.result
                }
            })
            
            getAllMemberName().then(result => {
                if (result.data.code !== 200) {
                    message.error(result.data.message);
                } else {
                    if (result.data.data) {
                        this.allUserList = result.data.data.map(item => {
                            return { ...item, key: item.userId, label: item.nickName };
                        });
                    }
                }
            });
        },
        handleChangeOnRole(key) {
            this.currentProjectGroup.roleId = key
            this.roleList.forEach(role => {
                if (role.roleId === key) {
                    this.currentProjectGroup.currentRoleName = role.roleName
                    this.currentProjectGroup.name = this.currentProjectGroup.currentProjectName +
                        this.currentProjectGroup.currentRoleName + "组"
                }
            })
        },
        handleChangeOnProject(key) {
            this.projectDataList.forEach(project => {
                this.currentProjectGroup.projectId = key
                if (project.appId === key) {
                    this.currentProjectGroup.currentProjectName = project.cnName
                    this.currentProjectGroup.name = this.currentProjectGroup.currentProjectName +
                        this.currentProjectGroup.currentRoleName + "组"
                }
            })
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                projectId: undefined,
                roleId: undefined,
                name: undefined,
            };
            this.resetForm('form');
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm('queryForm');
            this.queryParams = {}
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '添加项目组';
            this.updateStatus = false
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.dictId);
            this.single = selection.length != 1;
            this.multiple = !selection.length;
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.open = true;
            this.title = '修改项目组';
            this.updateStatus = true
            this.currentProjectGroup = deepCopy(row);
            this.roleList.forEach(role => {
                if (role.roleId === row.roleId) {
                    this.currentProjectGroup.currentRoleName = role.roleName
                    this.currentProjectGroup.name = this.currentProjectGroup.currentProjectName +
                        this.currentProjectGroup.currentRoleName + "组"
                }
            })
            this.projectDataList.forEach(project => {
                if (project.appId === row.projectId) {
                    this.currentProjectGroup.currentProjectName = project.cnName
                    this.currentProjectGroup.name = this.currentProjectGroup.currentProjectName +
                        this.currentProjectGroup.currentRoleName + "组"
                }
            })
        },
        /** 提交按钮 */
        submitForm: function() {
            if (!this.currentProjectGroup.name) {
                message.warning("请选择项目组信息")
                return
            }
            if (!this.currentProjectGroup.projectId) {
                message.warning("请选择项目")
                return
            }
            if (!this.currentProjectGroup.roleId) {
                message.warning("请选择角色")
                return
            }
            if (this.updateStatus) {
                updateProjectGroup(this.currentProjectGroup).then(result => {
                    if (result.code === 200) {
                        message.success("修改")
                        this.getList()
                        this.open = false
                    }
                })
            }else {
                insertProjectGroup(this.currentProjectGroup.name, this.currentProjectGroup.projectId, this.currentProjectGroup.roleId).then(result => {
                    if (result.code === 200) {
                        message.success("添加成功")
                        this.getList()
                        this.open = false
                    }
                })
            }
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除项目组"' + row.name + '"的数据项？').then(function() {
                return deleteProjectGroup(row.id)
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        /** 导出按钮操作 */
        handleExport() {
            this.download('system/dict/type/export', {
                ...this.queryParams
            }, `type_${new Date().getTime()}.xlsx`);
        },
        editGroupMember(value) {
            this.currentProjectGroup = deepCopy(value);
            this.addedUserList = [];
            this.groupUserIdList = [];
            queryGroupMembers(value.id).then(result => {
                if (result.code !== 200) {
                    message.error(result.message);
                    return;
                }
                
                this.groupUserIdList = result.data;
                this.allUserList.forEach(item => {
                    if (this.groupUserIdList.includes(item.userId)) {
                        this.addedUserList.push(item.userId);
                    }
                });
                
                this.openGroupMembers = true;
            });
        },
        cancelEditGroupMember() {
            this.openGroupMembers = false;
            this.addedUserList = [];
            this.groupUserIdList = [];
        },
        submitEditGroupMember() {
            const newAddUser = this.addedUserList.filter(item => !this.groupUserIdList.includes(item));
            const removeUser = this.groupUserIdList.filter(item => !this.addedUserList.includes(item));
            console.log('新添加', newAddUser);
            console.log('移除', removeUser);
            
            if (newAddUser.length === 0 && removeUser.length === 0) {
                message.error('当前没有需要移除或新增的人员');
                return;
            }
            
            let messageMessage = `是否确定从该${this.currentProjectGroup.name}项目组中`;
            if (newAddUser.length > 0) {
                messageMessage = messageMessage + `添加${newAddUser.length}个用户 `;
            }
            if (removeUser.length > 0) {
                messageMessage = messageMessage + `移除${removeUser.length}个用户?`;
            }
            
            let obj = this;
            this.$modal.confirm(messageMessage).then(function() {
                return new Promise((resolve, reject) => {
                    if (newAddUser.length > 0) {
                        let userList = newAddUser.map(item => {
                            return { userId: item };
                        });
                        insertProjectGroupsForUsers(userList, [obj.currentProjectGroup]).then(result => {
                            if (result.code === 200) {
                                message.success(`已添加${newAddUser.length}个用户到项目组`);
                                resolve();
                            }
                        });
                    }
                    
                    if (removeUser.length > 0) {
                        let userList = removeUser.map(item => {
                            return { userId: item };
                        });
                        deleteUsersFromProjectGroup(userList, [obj.currentProjectGroup]).then(result => {
                            if (result.code === 200) {
                                message.success(`已从项目组中移除${removeUser.length}个用户`);
                                resolve();
                            }
                        });
                    }
                });
            }).then((result) => {
                this.getList();
                this.cancelEditGroupMember();
            }).catch(() => {
            });
        }
    }
};
</script>